import { createGlobalStyle } from 'styled-components';

import { ids } from '@icarros/theme-react';
import { hexToRgba } from '@icarros/utils-react';

export const GlobalStyles = createGlobalStyle`

  :root {
    --content-z: 0;
    --over-content-z: 1;
    --overlay-z: 2;
    --sidebar-overlay-z: 3;
    --modal-z: 10;
  }

  body:has(.hide-header) {
    header#torque-header-menu, footer.footer-v2, #header-block-spacing {
      display: none;
      visibility: hidden;
    }
  }

  .Toastify {
    z-index: var(--over-content-z);
    &__toast--default {
    border-radius: 10px;
      padding: 0;
      min-height: 0;
    }
    &__toast-body {
      margin: 0;
    }
    &__toast-container {
      &--top-center {
          width: 90vw;
          left: 5vw;
          margin: 0;
          padding: 0px;
          top: 1em;

      }
      @media (min-width: 1366px) {
        &--top-center {
          width: 80vw;
          left: 10vw;
          margin: 0;
          padding: 0px;
        }
      }
    }
  }

  .main-content {
    margin: 0 auto;
    max-width: 425px;
    padding-inline: 20px;
    padding-bottom: 64px;

    @media (min-width: 426px) {
      max-width: 768px;
      width: 100%;
      padding-inline: 40px;
    }
    @media (min-width: 768px) {
      max-width: 1168px;
      width: 100%;
      padding-inline: 60px;
    }
  }

  .my-data .my-data-form-section__fields {
    margin-top: -12px;
  }

  // Titles

  .my-data__main-title {
    margin-top: 0;
    padding-top: 16px;
  }

  .my-data__main-title, .my-favorites__main-title, .my-insurances__main-title, .my-listings__main-title, .not-found__title {
    //$ids_textStyle_title_small_bold
    font-family: ${ids.foundation_text.family.text_itauDisplay_family};
    font-size: ${ids.foundation_size.medium.size_medium_28};
    line-height: ${ids.foundation_size.medium.size_medium_40};
    font-weight: ${ids.foundation_text.weight.text_itauDisplay_weight_700};
    text-transform: lowercase;
  }

  .section-title {
    ${ids.text.body.ids_textStyle_body_02_bold}
    text-transform: lowercase;
    color: ${ids.color.text.heading.ids_color_text_heading_02};
    margin-bottom: 12px;
  }

  .not-found {
    padding-top: 80px;
  }

  .empty-state__title {
    //$ids_textStyle_title_xsmall_bold
    font-family: ${ids.foundation_text.family.text_itauText_family};
    font-size: ${ids.foundation_size.small.size_small_20};
    line-height: ${ids.foundation_size.medium.size_medium_28};
    font-weight: ${ids.foundation_text.weight.text_itauDisplay_weight_700};
    color: ${ids.color.text.heading.ids_color_text_heading_02};

  }

  // Subtitle

  .empty-state__subtitle, .not-found__subtitle {
    ${ids.text.body.ids_textStyle_body_02_regular}
    color: ${ids.color.text.body.ids_color_text_body_02};
    max-width: 500px;
    text-align: center;
  }

  .empty-state__subtitle, .not-found__subtitle a {
    font-size: 14px !important;
  }

  // Inputs

  .torque-text-field > .torque-label, .torque-select-box > .torque-label {
    ${ids.text.label.ids_textStyle_label_xsmall_regular}
    text-transform: lowercase;
    color: ${ids.color.action.neutral.ids_color_action_neutral_base};
  }

  .torque-text-field > .torque-input, .torque-select-box > .torque-input {
    ${ids.text.label.ids_textStyle_label_small_regular}
    border-color: ${ids.color.border.ids_color_border_soft};
    background-color: ${ids.color.backgrounds.ids_color_bg_base};
  }

  .torque-text-field > .torque-input:focus, .torque-select-box > .torque-input:focus {
    border-color: ${ids.color.action.primary.ids_color_action_primary_base};
  }

  .torque-text-field--error > .torque-input, .torque-select-box--error > .torque-input {
    border-color: ${ids.color.feedbacks.ids_color_feedback_error};
  }

  .torque-text-field--error .torque-text--helper, .torque-text-field--error .torque-label, .torque-select-box--error > .torque-label {
    color: ${ids.color.feedbacks.ids_color_feedback_error};
  }

  // Checkboxes

  .torque-checkbox > .torque-label:before {
    background-color: ${ids.color.backgrounds.ids_color_bg_base};
    border-color: ${ids.color.border.ids_color_border_soft};
  }

  .torque-checkbox > .torque-input:checked + .torque-label:before {
    border-color: ${ids.color.action.primary.ids_color_action_primary_base} !important;
    background-color: ${ids.color.action.primary.ids_color_action_primary_base} !important;
  }

  .torque-checkbox > .torque-label {
    ${ids.text.label.ids_textStyle_label_small_regular}
  }

  // Disclaimer

  .disclaimer {
    ${ids.text.body.ids_textStyle_body_02_regular}
    border-radius: 12px;
    box-shadow: none;
    text-transform: lowercase;
    color: ${ids.color.text.body.ids_color_text_body_01};
    background-color: ${ids.color.backgrounds.ids_color_bg_base};
    border: 1px solid ${ids.color.feedbacks.ids_color_feedback_alert};

    svg path {
      stroke: ${ids.color.feedbacks.ids_color_feedback_alert};
    }
  }

  // Description

  .my-data .single-line__title {
    ${ids.text.body.ids_textStyle_body_02_regular}
  }

  // Button Primary

  .torque-button--primary.torque-button--color-primary {
    ${ids.text.label.ids_textStyle_label_medium_bold}
    border-radius: 8px;
    color: ${ids.color.action.secondary.ids_color_action_secondary_variant};
    border-color: ${ids.color.action.primary.ids_color_action_primary_variant};
    background-color: ${ids.color.action.primary.ids_color_action_primary_base};
    color: ${ids.color.action.primary.ids_color_action_primary_contrast};
    text-transform: lowercase;
    box-shadow: none;

    &:hover {
      border-color: ${ids.color.action.primary.ids_color_action_primary_variant};
      background-color: ${ids.color.action.primary.ids_color_action_primary_variant};
    }
  }

  // Button Secondary

  .torque-button--secondary.torque-button--color-secondary {
    ${ids.text.label.ids_textStyle_label_medium_bold}
    border-radius: 8px;
    color: ${ids.color.action.secondary.ids_color_action_secondary_variant};
    border-color: ${ids.color.action.secondary.ids_color_action_secondary_base};
    background-color: ${ids.color.action.secondary.ids_color_action_secondary_contrast};
    text-transform: lowercase;

    &:hover {
      background-color: ${hexToRgba(
        ids.color.action.secondary.ids_color_action_secondary_base,
        0.1
      )};
    }
  }

  // Card

  .card-image__main-photo-container {
    max-height: 224px;
  }

  .listing-item .torque-card {
    box-shadow: none;
    border-radius: 12px;
    border: 1px solid ${ids.color.border.ids_color_border_soft};
  }

  .listing-item__price {
    ${ids.text.body.ids_textStyle_body_01_bold}
    color: ${ids.color.text.heading.ids_color_text_heading_01};
  }

  .listing-item__name {
    ${ids.text.label.ids_textStyle_label_small_bold}
    color: ${ids.color.text.link.ids_color_text_link_secondary_base};
  }

  .listing-item__model {
    ${ids.text.body.ids_textStyle_body_02_regular}
    color: ${ids.color.text.body.ids_color_text_body_02};
  }

  .listing-item__feature {
    ${ids.text.body.ids_textStyle_body_02_bold}
    color: ${ids.color.text.body.ids_color_text_body_02};
    text-transform: lowercase;
  }

  .listing-item__description {
    ${ids.text.body.ids_textStyle_body_01_regular}
    color: ${ids.color.text.heading.ids_color_text_heading_02};
  }

  .listing-item .torque-line-separator {
    border-color: ${ids.color.border.ids_color_border_soft};
  }

  .listing-item .actions-container__item {
    //$ids_textStyle_overline_small_regular
    font-family: ${ids.foundation_text.family.text_itauText_family};
    font-size: ${ids.foundation_size.small.size_small_12};
    line-height: ${ids.foundation_size.small.size_small_16};
    font-weight: ${ids.foundation_text.weight.text_itauText_weight_400};
    color: ${ids.color.text.body.ids_color_text_body_02};
  }

  .listing-item .actions-container__button {
    ${ids.text.label.ids_textStyle_label_small_bold}
    text-transform: lowercase;
    color: ${ids.color.action.primary.ids_color_action_primary_variant};

    &:hover {
      background-color: ${ids.color.backgrounds.ids_color_bg_variant_01};
    }
  }


  .torque-card, .card {
    box-shadow: none;
    border-radius: 12px;
    border: 1px solid ${ids.color.border.ids_color_border_soft};

    :hover, .card:not(.card-disabled):hover {
      background: ${ids.color.backgrounds.ids_color_bg_variant_01} !important;
    }

    :hover, .card:not(.card-disabled):hover {
      box-shadow: none !important;
    }
  }


  // Paginate

  .torque-paginate__page {
    ${ids.text.label.ids_textStyle_label_medium_bold}
    padding-block: 4px;
    color: ${ids.color.action.primary.ids_color_action_primary_variant};

    &:hover {
      background-color: ${ids.color.backgrounds.ids_color_bg_variant_01};
    }
  }

  .torque-paginate__page--current {
    color: ${ids.color.border.ids_color_border_soft};
    background-color: ${ids.color.action.primary.ids_color_action_primary_base};
  }

  .torque-paginate__anchor {
    svg {
      fill: ${ids.color.action.primary.ids_color_action_primary_base};
    }

    &:hover {
        svg {
        fill: ${ids.color.action.primary.ids_color_action_primary_variant};
      }
    }
  }

  .torque-paginate__anchor--disabled {
    svg {
      fill: ${ids.color.action.disabled.ids_color_action_disabled_base};
    }
  }

  // Terms list

  .terms__decimal-item {
    ${ids.text.body.ids_textStyle_body_02_regular}
    color: ${ids.color.text.body.ids_color_text_body_02};

  }

  .terms__decimal-item strong {
    ${ids.text.body.ids_textStyle_body_02_bold}
    color: ${ids.color.text.body.ids_color_text_body_02};
  }

  // Misc

`;
